import { IAssetRow } from '../IAssetRow';
import React from 'react';
import { IAsset } from '../IAsset';
import { AssetDetailsFiles } from './AssetDetailsFiles';
import {
  FormLeftSection,
  FormRightSection,
  StyledFormFieldsContainer,
} from 'app/components/Forms/FormsLayout';
import { GetRowsSections } from './Utils';
import { RenderLeftSection, RenderRightSection } from './RenderAssetRows';
import { useSelector } from 'react-redux';
import {
  selectGlobalServiceGroupFilter,
  selectGlobalSettingBool,
  selectIsAuthenticated,
} from 'app/slice/selectors';
import { AllowedSettings } from 'utils/globalSettings';
import { MismatchCore, MismatchCoreMessage } from './MismatchCoreMessage';

export interface AssetDetailsTabContentProps {
  rows: IAssetRow[];
  data: IAsset;
  loadingAdditionalData?: boolean;
  isAdmin: boolean;
  commentsForStaff?: boolean;
  shortView?: boolean;
  isCover?: boolean;
}

export function AssetDetailsTabContent(props: AssetDetailsTabContentProps) {
  const { rows, data, shortView, isCover } = props;
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const topServiceGroupsIsHidden = useSelector(state =>
    selectGlobalSettingBool(state, AllowedSettings.HideTopServiceGroupFilter),
  );
  const selectedServiceGroups = useSelector(selectGlobalServiceGroupFilter);
  const sections = React.useMemo(() => {
    return GetRowsSections(rows, data, shortView);
  }, [data, shortView, rows]);
  const leftSections = React.useMemo(() => {
    return sections.leftSections;
  }, [sections]);
  const rightSections = React.useMemo(() => {
    return sections.rightSections;
  }, [sections]);
  // const getMobileRows = React.useCallback(() => {
  //   let res = leftSections;
  //   if (rightSections.length > 0 && rightSections[0].rows.length > 0) {
  //     res.unshift(...rightSections);
  //   }
  //   return res;
  // }, [leftSections, rightSections]);
  const mismatchCore = React.useMemo(() => {
    return MismatchCore(
      data,
      isAuthenticated,
      topServiceGroupsIsHidden,
      selectedServiceGroups,
    );
  }, [data, isAuthenticated, selectedServiceGroups, topServiceGroupsIsHidden]);
  return (
    <>
      <StyledFormFieldsContainer noPadding isCover={isCover}>
        <FormLeftSection isCover={isCover}>
          {shortView && (
            <MismatchCoreMessage data={data} mismatchCore={mismatchCore} />
          )}
          <RenderLeftSection sections={leftSections} data={data} />
        </FormLeftSection>
        <FormRightSection isCover={isCover}>
          {!shortView && (
            <MismatchCoreMessage data={data} mismatchCore={mismatchCore} />
          )}

          <RenderRightSection sections={rightSections} data={data} />
        </FormRightSection>
      </StyledFormFieldsContainer>
      {!!data && isAuthenticated && (
        <AssetDetailsFiles
          assetId={data.Id}
          isMobile={shortView}
          serviceGroupId={data.ServiceGroup.Id}
          availabilityType={data.AvailabilityType.Id}
        />
      )}

      {/*TODO: should be implemented mobile floating comment component and separate input from comments section
      Jira task BKT-9685*/}
      {/* {isMobile && (
        <AssetMobileComments
          isAdmin={isAdmin}
          assetId={data.Id}
          staffonly={commentsForStaff || false}
        />
      )} */}
    </>
  );
}
